import React from "react"

class ChooseDeliveryAddress extends React.Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div
        className={
          'checkout-sub-panel ' + (!this.props.signed_in ? 'guest-choose' : '')
        }
      >
        <div className="fl-on fl-jc-sb">
          <div className="fl-fb-50">
            {this.props.signed_in && <h2>Delivery Address</h2>}
            <ul className="address-options">
              {this.props.signed_in && (
                <li>
                  <label htmlFor="INVOICE_ADDRESS">
                    <input
                      type="radio"
                      id="INVOICE_ADDRESS"
                      checked={this.props.addressMode === 'INVOICE_ADDRESS'}
                      onChange={() => {
                        this.props.setAddressMode('INVOICE_ADDRESS');
                        this.props.setInvoiceAddressAsDeliveryAddress();
                      }}
                    />
                    <span>Deliver to Invoice Address</span>
                  </label>
                </li>
              )}
              {this.props.signed_in && (
                <li>
                  <label htmlFor="ADDRESS_BOOK">
                    <input
                      type="radio"
                      id="ADDRESS_BOOK"
                      checked={this.props.addressMode === 'ADDRESS_BOOK'}
                      onChange={() => {
                        this.props.setAddressMode('ADDRESS_BOOK');
                      }}
                    />
                    <span>Choose from Address Book</span>
                  </label>
                </li>
              )}
              {this.props.signed_in && (
                <li>
                  <label htmlFor="NEW_ADDRESS">
                    <input
                      type="radio"
                      id="NEW_ADDRESS"
                      checked={this.props.addressMode === 'NEW_ADDRESS'}
                      onChange={() => {
                        this.props.setAddressMode('NEW_ADDRESS');
                      }}
                    />
                    <span>Enter a New Address</span>
                  </label>
                </li>
              )}
              {!this.props.signed_in && (
                <li>
                  <label htmlFor="GUEST_NEW_ADDRESS">
                    <input
                      type="radio"
                      id="GUEST_NEW_ADDRESS"
                      checked={this.props.addressMode === 'GUEST_NEW_ADDRESS'}
                      onChange={() => {
                        this.props.setAddressMode('GUEST_NEW_ADDRESS');
                      }}
                    />
                    <span>Enter a New Address</span>
                  </label>
                </li>
              )}
              <li>
                <label htmlFor="BRANCH_DELIVERY">
                  <input
                    type="radio"
                    id="BRANCH_DELIVERY"
                    checked={this.props.addressMode === 'BRANCH_DELIVERY'}
                    onChange={() => {
                      this.props.setAddressModeRemoveAddresses(
                        'BRANCH_DELIVERY'
                      );
                    }}
                  />
                  <span>Deliver to a Store</span>
                </label>
              </li>
            </ul>
          </div>

          {this.props.signed_in && (
            <div className="fl-fb-50">
              <div className="account-address-container">
                <div>
                  <h2>Invoice Address</h2>
                  <p className="invoice-address">
                    <strong>{this.props.invoiceAddress.name}</strong>
                    <br />
                    {this.props.invoiceAddress.line_1}
                    <br />
                    {this.props.invoiceAddress.line_2}
                    <br />
                    {this.props.invoiceAddress.line_3}
                    <br />
                    {this.props.invoiceAddress.line_4}
                    <br />
                    {this.props.invoiceAddress.line_5}
                    <br />
                    {this.props.invoiceAddress.postcode}
                    <br />
                  </p>
                </div>
                <div>
                  <h2>Account Number</h2>
                  <p>{this.props.account.number}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ChooseDeliveryAddress;
